import { defineEnvironment } from './common';

/**
 * You can run the command `ionic serve --configuration=tenant` to test in a
 * prod-style environment.
 *
 * CI/CD will replace this with the correct url for the tenant.
 */

export const environment = defineEnvironment({
	production: true,
	type: 'prod',
	baseUrl: 'https://milktracker.angeleyehealth.com',
	apiUrl: 'https://milktracker-api.angeleyehealth.com/api/v1',
	authAppBaseUrl: 'https://auth.angeleyehealth.com',
	portalUrl: 'https://milktracker-api.angeleyehealth.com/portal',
	settings: {
		clerkSignInURL: 'https://auth.angeleyehealth.com/milktracker/sign-in',
		clerkSignOutURL: 'https://auth.angeleyehealth.com/milktracker/sign-out',
		kioskSessionLengthInMinutes: 1,
	},
});
